import { DialogActions, DialogContent, Button, CircularProgress, Grid, Tooltip } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import UrlValidationFormField from 'v2/components/Shared/UrlValidationFormField';
import { WebhookContentTypeAlias, WebhookTypes } from 'v2/interfaces/webhook2';

import type { FieldsWebHook } from 'v2/interfaces/webhook2';

import { useWebhookContext } from '../context';

const MOZ_CONTENT_TYPE_URL = 'https://developer.mozilla.org/pt-BR/docs/Web/HTTP/Headers/Content-Type';

const Fields = React.memo(() => {
  const { setSelectedWebhook, setIsFormOpen } = useWebhookContext();
  const { isSubmitting, isValid, values } = useFormikContext<FieldsWebHook>();
  const [isUrlValidated, setIsUrlValidated] = React.useState(false);
  const [resetValidation, setResetValidation] = React.useState(0);

  const onClose = React.useCallback(() => {
    setSelectedWebhook(null);
    setIsFormOpen(false);
  }, [setIsFormOpen, setSelectedWebhook]);

  const editing = !!values?._id;

  const unvalidateOnChange = useCallback(() => {
    setResetValidation((prev) => prev + 1);
    setIsUrlValidated(false);
  }, [setIsUrlValidated]);

  return (
    <>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Field id='description' name='description' label='Nome da configuração *' fullWidth component={TextFormField} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Field id='type' name='type' label='Tipo (evento) *' disabled={editing} fullWidth options={WebhookTypes} component={SelectFormField} />
          </Grid>

          <Grid item xs={12}>
            <Field
              id='product_id'
              name='product_id'
              disabled={editing}
              label='Selecione o(s) produto(s) *'
              endpoint='/webhook/products'
              fullWidth
              single
              component={SelectProduct}
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              id='content_type'
              name='content_type'
              label='Formato de envio *'
              helperText={
                <>
                  Cabeçalho Content Type. Para saber mais{' '}
                  <a href={MOZ_CONTENT_TYPE_URL} target='_blank' rel='noreferrer'>
                    clique aqui.
                  </a>
                </>
              }
              fullWidth
              options={[
                { label: 'JSON', value: WebhookContentTypeAlias.json },
                { label: 'URL Encoded', value: WebhookContentTypeAlias.urlencoded },
              ]}
              component={SelectFormField}
              afterChange={unvalidateOnChange}
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              id='url'
              name='url'
              label='URL para envio de dados *'
              fullWidth
              component={UrlValidationFormField}
              resetValidation={resetValidation}
              helperText='Insira uma URL válida, obrigátorio http:// ou https://'
              onValidateUrl={setIsUrlValidated}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button disabled={isSubmitting} onClick={onClose}>
          Cancelar
        </Button>

        <Tooltip placement='top' title={!isUrlValidated && isValid ? 'Sua URL precisa ser validada e retornar status 200 para salvar' : ''}>
          <div>
            <Button
              disabled={isSubmitting || !isValid || !isUrlValidated}
              type='submit'
              variant='contained'
              color='primary'
              startIcon={isSubmitting && <CircularProgress size={16} />}
            >
              Salvar
            </Button>
          </div>
        </Tooltip>
      </DialogActions>
    </>
  );
});

export default Fields;
